import { BaseFetch } from "../main-model";
export default class StudentInAwardModel extends BaseFetch {
  getStudentInAwardBy = (data) =>
    this.authFetch({
      url: "student-in-award/getStudentInAwardBy",
      method: "POST",
      body: JSON.stringify(data),
    });
  getStudentInAwardById = (data) =>
    this.authFetch({
      url: "student-in-award/getStudentInAwardById",
      method: "POST",
      body: JSON.stringify(data),
    });
  updateStudentInAwardById = (data) =>
    this.authFetch({
      url: "student-in-award/updateStudentInAwardById",
      method: "POST",
      body: JSON.stringify(data),
    });
  insertStudentInAward = (data) =>
    this.authFetch({
      url: "student-in-award/insertStudentInAward",
      method: "POST",
      body: JSON.stringify(data),
    });
  deleteStudentInAwardById = (data) =>
    this.authFetch({
      url: "student-in-award/deleteStudentInAwardById",
      method: "POST",
      body: JSON.stringify(data),
    });
  updateStudentInAwardById = (data) =>
    this.authFetch({
      url: "student-in-award/updateStudentInAwardById",
      method: "POST",
      body: JSON.stringify(data),
    });
}
